const LARGE_SCALE_LABEL = 'Larga Escala'
const SPECIFIC_CRITERIA_LABEL = 'Critérios Específicos'
const SIGNIFICANTLY_AFFECT_LABEL = 'Afetar Significativamente'
const IMPACT_LABEL = 'Impacto'

const LARGE_SCALE_STEP = 0
const SPECIFIC_CRITERIA_STEP = 1
const SIGNIFICANTLY_AFFECT_STEP = 2
const IMPACT_STEP = 3

const LARGE_SCALE_ENUM = 'large_scale'
const SPECIFIC_CRITERIA_ENUM = 'specific_criteria'
const SIGNIFICANTLY_AFFECT_ENUM = 'significantly_affect'
const IMPACT_ENUM = 'impact'

const HIGH_RISK_STEPS = [
  LARGE_SCALE_STEP,
  SPECIFIC_CRITERIA_STEP,
  SIGNIFICANTLY_AFFECT_STEP,
  IMPACT_STEP,
]
const STEPS_LIST = [
  { value: LARGE_SCALE_ENUM, name: LARGE_SCALE_LABEL },
  { value: SPECIFIC_CRITERIA_ENUM, name: SPECIFIC_CRITERIA_LABEL },
  { value: SIGNIFICANTLY_AFFECT_ENUM, name: SIGNIFICANTLY_AFFECT_LABEL },
  { value: IMPACT_ENUM, name: IMPACT_LABEL },
]

const ENUMS_BY_STEP = {
  [LARGE_SCALE_STEP]: LARGE_SCALE_ENUM,
  [SPECIFIC_CRITERIA_STEP]: SPECIFIC_CRITERIA_ENUM,
  [SIGNIFICANTLY_AFFECT_STEP]: SIGNIFICANTLY_AFFECT_ENUM,
  [IMPACT_STEP]: IMPACT_ENUM,
}

const LABELS = {
  [LARGE_SCALE_ENUM]: LARGE_SCALE_LABEL,
  [SPECIFIC_CRITERIA_ENUM]: SPECIFIC_CRITERIA_LABEL,
  [SIGNIFICANTLY_AFFECT_ENUM]: SIGNIFICANTLY_AFFECT_LABEL,
  [IMPACT_ENUM]: IMPACT_LABEL,
}

const LARGE_SCALE_CARDS = [
  {
    id: 1,
    name: 'Quantidade e Volume',
    text: 'Número de Titulares: quantidade total de pessoas cujos dados pessoais são tratados pelo agente de tratamento. \n \nVolume médio de dados: média de dados pessoais por titular, calculada pela divisão do total de dados pessoais pelo número de titulares.',
  },
  {
    id: 2,
    name: 'Duração e Frequência',
    text: 'Duração do tratamento: período máximo, em anos, durante o qual os dados pessoais são tratados pelo agente de tratamento.\n \nFrequência do tratamento: periodicidade com que o tratamento ocorre, definida de acordo com a finalidade específica daquele tratamento.',
  },
  {
    id: 3,
    name: 'Extensão Geográfica',
    text: 'Extensão geográfica: Deve-se sempre considerar a maior extensão territorial possível dentro dos atuais limites em que o tratamento ocorre',
  },
]

const LARGE_SCALE_ANSWER_LABELS = {
  yes: 'Sim',
  no: 'Não',
  maybe: 'Avaliar',
}

const SPECIFIC_CRITERIA_ANSWER_LABELS = {
  true: 'Sim',
  false: 'Não',
}

const SIGNIFICANTLY_AFFECT_ANSWER_LABELS = {
  true: 'Sim',
  false: 'Não',
}

const IMPACT_ANSWER_LABELS = {
  true: 'Sim',
  false: 'Não',
}

export default {
  ENUMS_BY_STEP,
  HIGH_RISK_STEPS,
  IMPACT_ANSWER_LABELS,
  IMPACT_ENUM,
  LABELS,
  LARGE_SCALE_ANSWER_LABELS,
  LARGE_SCALE_CARDS,
  LARGE_SCALE_ENUM,
  SIGNIFICANTLY_AFFECT_ANSWER_LABELS,
  SIGNIFICANTLY_AFFECT_ENUM,
  SPECIFIC_CRITERIA_ANSWER_LABELS,
  SPECIFIC_CRITERIA_ENUM,
  STEPS_LIST,
}
